import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfigProvider, Image } from "antd";
import {
  setIsOpenSnack,
  setSnackMessage,
  setIsCopy,
} from "../redux/features/rewards/rewardsSlice";

import ICCopied from "../assets/images/svgs/ic_copied_reward.svg";

const SnackBarRedeem = ({ isMobileVersion }) => {
  const isOpenSnack = useSelector((state) => state.rewards.isOpenSnack);
  const snackMessage = useSelector((state) => state.rewards.snackMessage);
  const isCopy = useSelector((state) => state.rewards.isCopy);
  const snackBarTime = useSelector((state) => state.rewards.snackBarTime);
  const dispatch = useDispatch();

  const opened = () => {
    var snackelement = isCopy
      ? document.getElementById("snackbar-redeem")
      : document.getElementById("snackbar-redeem-ouch");

    // Add the "show" class to DIV
    snackelement.className = "show";

    // After 3 seconds, remove the show class from DIV
    setTimeout(function () {
      snackelement.className = snackelement.className.replace("show", "");
      dispatch(setIsCopy(false));
      dispatch(setSnackMessage(""));
      dispatch(setIsOpenSnack(false));
    }, snackBarTime);
  };

  useEffect(() => {
    if (isOpenSnack === true) opened();
  }, [isOpenSnack]);

  return (
    <div id={isCopy ? "snackbar-redeem" : "snackbar-redeem-ouch"}>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "Roboto",
          },
        }}
      >
        <div
          className="snack-copy"
          style={{ display: isCopy ? "block" : "none" }}
        >
          <div
            style={{
              background: "#292929",
              borderRadius: 4,
              width: "fit-content",
              color: "#FFFFFF",
              padding: "12px 16px",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              lineHeight: "normal",
            }}
          >
            <div style={{ marginRight: 8 }}>
              <Image
                width={20}
                height={20}
                preview={false}
                src={ICCopied}
                alt="icon copied"
              />
            </div>
            <div>{snackMessage}</div>
          </div>
        </div>
        <div
          className="snack-out"
          style={{ display: isCopy ? "none" : "block" }}
        >
          <div
            style={{
              background: "#292929",
              borderRadius: 4,
              width: "fit-content",
              color: "#FFFFFF",
              padding: "12px 16px",
              fontSize: "14px",
              lineHeight: "normal",
            }}
          >
            {snackMessage}
          </div>
        </div>
      </ConfigProvider>
    </div>
  );
};

export default SnackBarRedeem;
